<template>
    <div class="tabs-pane-wrap" v-show="show">
      <slot></slot>
    </div>
</template>

<script>
/**@augments filters 数组，结构如下
 */
export default {
  name: 'TabPane',
  props: {
    name: {
      type: String
    },
    label: {
      type: [String, Function],
      default: ''
    }
  },
  data () {
    return {
      show: true,
      currentName: this.name
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/TabPane.vue